import type { AnnouncementPopupProps } from "@9amhealth/shared";
import { Blac, Cubit } from "blac-next";

export type AnnouncementPopupConfig = AnnouncementPopupProps;

type AnnouncementPopupState = {
  config: AnnouncementPopupConfig | null;
};

export default class AnnouncementPopupCubit extends Cubit<AnnouncementPopupState> {
  static keepAlive = true;

  constructor() {
    super({ config: null });
  }

  show = (config: AnnouncementPopupConfig) => {
    this.patch({ config });
  };

  dismiss = () => {
    this.patch({ config: null });
  };
}

export const AnnouncementPopupController = Blac.getBloc(AnnouncementPopupCubit);
